module.exports = __webpack_public_path__ + "img/img_banner_about.cd064876.jpg";